import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { setPrevPage, setNextPage } from '../../../redux/slices/appStateSlice';

const ConfirmDetailsLogic = ({ fields, dependents }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (dependents?.spouse) {
      dispatch(setNextPage(fields.confirmPartnerDetailsPage?.value?.href));
    } else if (dependents?.children?.length === 1) {
      dispatch(setNextPage(fields.confirmChildDetailsPage?.value?.href));
    } else if (dependents?.children?.length > 1) {
      dispatch(setNextPage(fields.confirmChildrenDetailsPage?.value?.href));
    } else {
      dispatch(setNextPage(fields.yourAddressPage?.value?.href));
    }
  }, [dependents]);

  return <></>;
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    dependents: state.quoteData?.prospectDetails?.dependents,
  };
};
export default connect(mapStateToProps)(ConfirmDetailsLogic);
